import { AssetSchemaRootState } from '../store';

/**
 * Selects the asset schema from the root state.
 * @internal
 * @param state - The root state of the asset schema.
 * @returns The asset schema state.
 */
export const assetSchemaBaseSelector = (state: AssetSchemaRootState) =>
	state.assetSchema;
